module.exports = __webpack_public_path__ + "img/rca.084767b9.svg";